// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"7339367b","679":"2d0380e1"}[chunkId] + ".chunk.js";
};